import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ModelMaintenanceBuilder } from '../../models/builders/model-maintenance.builder';

@Injectable()
export class ModelMaintenanceApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }model-maintenances`;
  }

  getModelMaintenances() {
    return this.httpClient.get(this.apiUrl)
      .pipe(
        map(ModelMaintenanceBuilder.fromList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/model-maintenance-api.service.ts